$('body').css('scroll-snap-type', 'unset');

$('.nav-menu').addClass('active');

var rating = 5;

$(document).ready(function(){
    $('.preloader').css({'z-index': '-99999', 'opacity': '0'});

    $.getJSON('//www.mars-players.com/cdn/shop/t/3/assets/reviews.json?v=108215479965281822871678092668', function(data) {

        if (data[myId] != undefined) {
            let c = 0;
            let total_rate = 0;
            $.each(data[myId], function(i, item) {
                c++;
                total_rate += item.rate;
                
                if (item.rate == 1) {
                    $('#spr_reviews').append(
                        '<div class="col-lg-12 col-md-12 review">'+
                        '<div class="heading">'+
                            '<div class="star">'+
                                '<img src="//www.mars-players.com/cdn/shop/t/3/assets/1-star.png?v=48085895984148665771676446013" aria-label="1.0 of 5 ">'+
                                '<img src="//www.mars-players.com/cdn/shop/t/3/assets/2-star-o.png?v=64721735652002299201676446006" aria-label="2.0 of 5 ">'+
                                '<img src="//www.mars-players.com/cdn/shop/t/3/assets/3-star-o.png?v=67841821715999001661676446011" aria-label="3.0 of 5 ">'+
                                '<img src="//www.mars-players.com/cdn/shop/t/3/assets/4-star-o.png?v=22116135437275742541676446014" aria-label="4.0 of 5 ">'+
                                '<img src="//www.mars-players.com/cdn/shop/t/3/assets/5-star-o.png?v=28677156786108976321676446018" aria-label="5.0 of 5 ">'+
                            '</div>'+
                            '<h4 class="name f-white">'+item.name+'</h4>'+
                            '<p class="date">'+item.date+'</p>'+
                        '</div>'+
                        '<p class="content">'+item.body+'</p>'+
                    '</div>'
                    );
                }
                else if (item.rate == 2) {
                    $('#spr_reviews').append(
                        '<div class="col-lg-12 col-md-12 review">'+
                        '<div class="heading">'+
                            '<div class="star">'+
                                '<img src="//www.mars-players.com/cdn/shop/t/3/assets/1-star.png?v=48085895984148665771676446013" aria-label="1.0 of 5 ">'+
                                '<img src="//www.mars-players.com/cdn/shop/t/3/assets/2-star.png?v=55732684265038744541676446017" aria-label="2.0 of 5 ">'+
                                '<img src="//www.mars-players.com/cdn/shop/t/3/assets/3-star-o.png?v=67841821715999001661676446011" aria-label="3.0 of 5 ">'+
                                '<img src="//www.mars-players.com/cdn/shop/t/3/assets/4-star-o.png?v=22116135437275742541676446014" aria-label="4.0 of 5 ">'+
                                '<img src="//www.mars-players.com/cdn/shop/t/3/assets/5-star-o.png?v=28677156786108976321676446018" aria-label="5.0 of 5 ">'+
                            '</div>'+
                            '<h4 class="name f-white">'+item.name+'</h4>'+
                            '<p class="date">'+item.date+'</p>'+
                        '</div>'+
                        '<p class="content">'+item.body+'</p>'+
                    '</div>'
                    );
                }
                else if (item.rate == 3) {
                    $('#spr_reviews').append(
                        '<div class="col-lg-12 col-md-12 review">'+
                        '<div class="heading">'+
                            '<div class="star">'+
                                '<img src="//www.mars-players.com/cdn/shop/t/3/assets/1-star.png?v=48085895984148665771676446013" aria-label="1.0 of 5 ">'+
                                '<img src="//www.mars-players.com/cdn/shop/t/3/assets/2-star.png?v=55732684265038744541676446017" aria-label="2.0 of 5 ">'+
                                '<img src="//www.mars-players.com/cdn/shop/t/3/assets/3-star.png?v=111151071064792768091676446015" aria-label="3.0 of 5 ">'+
                                '<img src="//www.mars-players.com/cdn/shop/t/3/assets/4-star-o.png?v=22116135437275742541676446014" aria-label="4.0 of 5 ">'+
                                '<img src="//www.mars-players.com/cdn/shop/t/3/assets/5-star-o.png?v=28677156786108976321676446018" aria-label="5.0 of 5 ">'+
                            '</div>'+
                            '<h4 class="name f-white">'+item.name+'</h4>'+
                            '<p class="date">'+item.date+'</p>'+
                        '</div>'+
                        '<p class="content">'+item.body+'</p>'+
                    '</div>'
                    );
                }
                else if (item.rate == 4) {
                    $('#spr_reviews').append(
                        '<div class="col-lg-12 col-md-12 review">'+
                        '<div class="heading">'+
                            '<div class="star">'+
                                '<img src="//www.mars-players.com/cdn/shop/t/3/assets/1-star.png?v=48085895984148665771676446013" aria-label="1.0 of 5 ">'+
                                '<img src="//www.mars-players.com/cdn/shop/t/3/assets/2-star.png?v=55732684265038744541676446017" aria-label="2.0 of 5 ">'+
                                '<img src="//www.mars-players.com/cdn/shop/t/3/assets/3-star.png?v=111151071064792768091676446015" aria-label="3.0 of 5 ">'+
                                '<img src="//www.mars-players.com/cdn/shop/t/3/assets/4-star.png?v=13088529198068233611676446019" aria-label="4.0 of 5 ">'+
                                '<img src="//www.mars-players.com/cdn/shop/t/3/assets/5-star-o.png?v=28677156786108976321676446018" aria-label="5.0 of 5 ">'+
                            '</div>'+
                            '<h4 class="name f-white">'+item.name+'</h4>'+
                            '<p class="date">'+item.date+'</p>'+
                        '</div>'+
                        '<p class="content">'+item.body+'</p>'+
                    '</div>'
                    );
                }
                else if (item.rate == 5) {
                    $('#spr_reviews').append(
                        '<div class="col-lg-12 col-md-12 review">'+
                        '<div class="heading">'+
                            '<div class="star">'+
                                '<img src="//www.mars-players.com/cdn/shop/t/3/assets/1-star.png?v=48085895984148665771676446013" aria-label="1.0 of 5 ">'+
                                '<img src="//www.mars-players.com/cdn/shop/t/3/assets/2-star.png?v=55732684265038744541676446017" aria-label="2.0 of 5 ">'+
                                '<img src="//www.mars-players.com/cdn/shop/t/3/assets/3-star.png?v=111151071064792768091676446015" aria-label="3.0 of 5 ">'+
                                '<img src="//www.mars-players.com/cdn/shop/t/3/assets/4-star.png?v=13088529198068233611676446019" aria-label="4.0 of 5 ">'+
                                '<img src="//www.mars-players.com/cdn/shop/t/3/assets/5-star.png?v=9380944507700322041676446009" aria-label="5.0 of 5 ">'+
                            '</div>'+
                            '<h4 class="name f-white">'+item.name+'</h4>'+
                            '<p class="date">'+item.date+'</p>'+
                        '</div>'+
                        '<p class="content">'+item.body+'</p>'+
                    '</div>'
                    );
                }
            });
            let ave = (total_rate/c).toFixed(1);

            $('#spr_c').html('Rating based on '+c+' reviews.');
            $('#spr_ave').html(ave);

            if (ave == 0) {
                $('#allProducts-section-1 .rating').html(
                    '<div class="star">'+
                        '<img src="//www.mars-players.com/cdn/shop/t/3/assets/1-star-o.png?v=13961040043880060731676446008" aria-label="1.0 of 5 ">'+
                        '<img src="//www.mars-players.com/cdn/shop/t/3/assets/2-star-o.png?v=64721735652002299201676446006" aria-label="2.0 of 5 ">'+
                        '<img src="//www.mars-players.com/cdn/shop/t/3/assets/3-star-o.png?v=67841821715999001661676446011" aria-label="3.0 of 5 ">'+
                        '<img src="//www.mars-players.com/cdn/shop/t/3/assets/4-star-o.png?v=22116135437275742541676446014" aria-label="4.0 of 5 ">'+
                        '<img src="//www.mars-players.com/cdn/shop/t/3/assets/5-star-o.png?v=28677156786108976321676446018" aria-label="5.0 of 5 ">'+
                    '</div>'+
                    '<p class="description f-black">'+
                        '<small>'+ave+' based on '+c+' reviews.</small>'+
                    '</p>'
                );
            }
            else if (ave > 0 && ave < 1) {
                $('#allProducts-section-1 .rating').html(
                    '<div class="star">'+
                        '<img src="//www.mars-players.com/cdn/shop/t/3/assets/1-star-half.png?v=50810250365393759061678089630" aria-label="1.0 of 5 ">'+
                        '<img src="//www.mars-players.com/cdn/shop/t/3/assets/2-star-o.png?v=64721735652002299201676446006" aria-label="2.0 of 5 ">'+
                        '<img src="//www.mars-players.com/cdn/shop/t/3/assets/3-star-o.png?v=67841821715999001661676446011" aria-label="3.0 of 5 ">'+
                        '<img src="//www.mars-players.com/cdn/shop/t/3/assets/4-star-o.png?v=22116135437275742541676446014" aria-label="4.0 of 5 ">'+
                        '<img src="//www.mars-players.com/cdn/shop/t/3/assets/5-star-o.png?v=28677156786108976321676446018" aria-label="5.0 of 5 ">'+
                    '</div>'+
                    '<p class="description f-black">'+
                        '<small>'+ave+' based on '+c+' reviews.</small>'+
                    '</p>'
                );
            }
            else if (ave == 1) {
                $('#allProducts-section-1 .rating').html(
                    '<div class="star">'+
                        '<img src="//www.mars-players.com/cdn/shop/t/3/assets/1-star.png?v=48085895984148665771676446013" aria-label="1.0 of 5 ">'+
                        '<img src="//www.mars-players.com/cdn/shop/t/3/assets/2-star-o.png?v=64721735652002299201676446006" aria-label="2.0 of 5 ">'+
                        '<img src="//www.mars-players.com/cdn/shop/t/3/assets/3-star-o.png?v=67841821715999001661676446011" aria-label="3.0 of 5 ">'+
                        '<img src="//www.mars-players.com/cdn/shop/t/3/assets/4-star-o.png?v=22116135437275742541676446014" aria-label="4.0 of 5 ">'+
                        '<img src="//www.mars-players.com/cdn/shop/t/3/assets/5-star-o.png?v=28677156786108976321676446018" aria-label="5.0 of 5 ">'+
                    '</div>'+
                    '<p class="description f-black">'+
                        '<small>'+ave+' based on '+c+' reviews.</small>'+
                    '</p>'
                );
            }
            else if (ave > 1 && ave < 2) {
                $('#allProducts-section-1 .rating').html(
                    '<div class="star">'+
                        '<img src="//www.mars-players.com/cdn/shop/t/3/assets/1-star.png?v=48085895984148665771676446013" aria-label="1.0 of 5 ">'+
                        '<img src="//www.mars-players.com/cdn/shop/t/3/assets/2-star-half.png?v=24422924821710740311678090087" aria-label="2.0 of 5 ">'+
                        '<img src="//www.mars-players.com/cdn/shop/t/3/assets/3-star-o.png?v=67841821715999001661676446011" aria-label="3.0 of 5 ">'+
                        '<img src="//www.mars-players.com/cdn/shop/t/3/assets/4-star-o.png?v=22116135437275742541676446014" aria-label="4.0 of 5 ">'+
                        '<img src="//www.mars-players.com/cdn/shop/t/3/assets/5-star-o.png?v=28677156786108976321676446018" aria-label="5.0 of 5 ">'+
                    '</div>'+
                    '<p class="description f-black">'+
                        '<small>'+ave+' based on '+c+' reviews.</small>'+
                    '</p>'
                );
            }
            else if (ave == 2) {
                $('#allProducts-section-1 .rating').html(
                    '<div class="star">'+
                        '<img src="//www.mars-players.com/cdn/shop/t/3/assets/1-star.png?v=48085895984148665771676446013" aria-label="1.0 of 5 ">'+
                        '<img src="//www.mars-players.com/cdn/shop/t/3/assets/2-star.png?v=55732684265038744541676446017" aria-label="2.0 of 5 ">'+
                        '<img src="//www.mars-players.com/cdn/shop/t/3/assets/3-star-o.png?v=67841821715999001661676446011" aria-label="3.0 of 5 ">'+
                        '<img src="//www.mars-players.com/cdn/shop/t/3/assets/4-star-o.png?v=22116135437275742541676446014" aria-label="4.0 of 5 ">'+
                        '<img src="//www.mars-players.com/cdn/shop/t/3/assets/5-star-o.png?v=28677156786108976321676446018" aria-label="5.0 of 5 ">'+
                    '</div>'+
                    '<p class="description f-black">'+
                        '<small>'+ave+' based on '+c+' reviews.</small>'+
                    '</p>'
                );
            }
            else if (ave > 2 && ave < 3) {
                $('#allProducts-section-1 .rating').html(
                    '<div class="star">'+
                        '<img src="//www.mars-players.com/cdn/shop/t/3/assets/1-star.png?v=48085895984148665771676446013" aria-label="1.0 of 5 ">'+
                        '<img src="//www.mars-players.com/cdn/shop/t/3/assets/2-star.png?v=55732684265038744541676446017" aria-label="2.0 of 5 ">'+
                        '<img src="//www.mars-players.com/cdn/shop/t/3/assets/3-star-half.png?v=180348759796153708751678090134" aria-label="3.0 of 5 ">'+
                        '<img src="//www.mars-players.com/cdn/shop/t/3/assets/4-star-o.png?v=22116135437275742541676446014" aria-label="4.0 of 5 ">'+
                        '<img src="//www.mars-players.com/cdn/shop/t/3/assets/5-star-o.png?v=28677156786108976321676446018" aria-label="5.0 of 5 ">'+
                    '</div>'+
                    '<p class="description f-black">'+
                        '<small>'+ave+' based on '+c+' reviews.</small>'+
                    '</p>'
                );
            }
            else if (ave == 3) {
                $('#allProducts-section-1 .rating').html(
                    '<div class="star">'+
                        '<img src="//www.mars-players.com/cdn/shop/t/3/assets/1-star.png?v=48085895984148665771676446013" aria-label="1.0 of 5 ">'+
                        '<img src="//www.mars-players.com/cdn/shop/t/3/assets/2-star.png?v=55732684265038744541676446017" aria-label="2.0 of 5 ">'+
                        '<img src="//www.mars-players.com/cdn/shop/t/3/assets/3-star.png?v=111151071064792768091676446015" aria-label="3.0 of 5 ">'+
                        '<img src="//www.mars-players.com/cdn/shop/t/3/assets/4-star-o.png?v=22116135437275742541676446014" aria-label="4.0 of 5 ">'+
                        '<img src="//www.mars-players.com/cdn/shop/t/3/assets/5-star-o.png?v=28677156786108976321676446018" aria-label="5.0 of 5 ">'+
                    '</div>'+
                    '<p class="description f-black">'+
                        '<small>'+ave+' based on '+c+' reviews.</small>'+
                    '</p>'
                );
            }
            else if (ave > 3 && ave < 4) {
                $('#allProducts-section-1 .rating').html(
                    '<div class="star">'+
                        '<img src="//www.mars-players.com/cdn/shop/t/3/assets/1-star.png?v=48085895984148665771676446013" aria-label="1.0 of 5 ">'+
                        '<img src="//www.mars-players.com/cdn/shop/t/3/assets/2-star.png?v=55732684265038744541676446017" aria-label="2.0 of 5 ">'+
                        '<img src="//www.mars-players.com/cdn/shop/t/3/assets/3-star.png?v=111151071064792768091676446015" aria-label="3.0 of 5 ">'+
                        '<img src="//www.mars-players.com/cdn/shop/t/3/assets/4-star-half.png?v=115814877005687386111678090169" aria-label="4.0 of 5 ">'+
                        '<img src="//www.mars-players.com/cdn/shop/t/3/assets/5-star-o.png?v=28677156786108976321676446018" aria-label="5.0 of 5 ">'+
                    '</div>'+
                    '<p class="description f-black">'+
                        '<small>'+ave+' based on '+c+' reviews.</small>'+
                    '</p>'
                );
            }
            else if (ave == 4) {
                $('#allProducts-section-1 .rating').html(
                    '<div class="star">'+
                        '<img src="//www.mars-players.com/cdn/shop/t/3/assets/1-star.png?v=48085895984148665771676446013" aria-label="1.0 of 5 ">'+
                        '<img src="//www.mars-players.com/cdn/shop/t/3/assets/2-star.png?v=55732684265038744541676446017" aria-label="2.0 of 5 ">'+
                        '<img src="//www.mars-players.com/cdn/shop/t/3/assets/3-star.png?v=111151071064792768091676446015" aria-label="3.0 of 5 ">'+
                        '<img src="//www.mars-players.com/cdn/shop/t/3/assets/4-star.png?v=13088529198068233611676446019" aria-label="4.0 of 5 ">'+
                        '<img src="//www.mars-players.com/cdn/shop/t/3/assets/5-star-o.png?v=28677156786108976321676446018" aria-label="5.0 of 5 ">'+
                    '</div>'+
                    '<p class="description f-black">'+
                        '<small>'+ave+' based on '+c+' reviews.</small>'+
                    '</p>'
                );
            }
            else if (ave > 4 && ave < 5) {
                $('#allProducts-section-1 .rating').html(
                    '<div class="star">'+
                        '<img src="//www.mars-players.com/cdn/shop/t/3/assets/1-star.png?v=48085895984148665771676446013" aria-label="1.0 of 5 ">'+
                        '<img src="//www.mars-players.com/cdn/shop/t/3/assets/2-star.png?v=55732684265038744541676446017" aria-label="2.0 of 5 ">'+
                        '<img src="//www.mars-players.com/cdn/shop/t/3/assets/3-star.png?v=111151071064792768091676446015" aria-label="3.0 of 5 ">'+
                        '<img src="//www.mars-players.com/cdn/shop/t/3/assets/4-star.png?v=13088529198068233611676446019" aria-label="4.0 of 5 ">'+
                        '<img src="//www.mars-players.com/cdn/shop/t/3/assets/5-star-half.png?v=11401642620559201391678089998" aria-label="5.0 of 5 ">'+
                    '</div>'+
                    '<p class="description f-black">'+
                        '<small>'+ave+' based on '+c+' reviews.</small>'+
                    '</p>'
                );
            }
            else if (ave == 5) {
                $('#allProducts-section-1 .rating').html(
                    '<div class="star">'+
                        '<img src="//www.mars-players.com/cdn/shop/t/3/assets/1-star.png?v=48085895984148665771676446013" aria-label="1.0 of 5 ">'+
                        '<img src="//www.mars-players.com/cdn/shop/t/3/assets/2-star.png?v=55732684265038744541676446017" aria-label="2.0 of 5 ">'+
                        '<img src="//www.mars-players.com/cdn/shop/t/3/assets/3-star.png?v=111151071064792768091676446015" aria-label="3.0 of 5 ">'+
                        '<img src="//www.mars-players.com/cdn/shop/t/3/assets/4-star.png?v=13088529198068233611676446019" aria-label="4.0 of 5 ">'+
                        '<img src="//www.mars-players.com/cdn/shop/t/3/assets/5-star.png?v=9380944507700322041676446009" aria-label="5.0 of 5 ">'+
                    '</div>'+
                    '<p class="description f-black">'+
                        '<small>'+ave+' based on '+c+' reviews.</small>'+
                    '</p>'
                );
            }

            $('#allProducts-section-1 .rating').show();
        }
        else {
            $('#spr_c').html('No reviews yet.');
            $('#spr_ave').html('00');

            $('#product-section-9 .reviews').hide();
            $('#product-section-9 .write').show();
            $('#product-section-9 .write .close-button').hide();

            $('#allProducts-section-1 .rating').hide();
        }
    });

    let contact_posted = getSearchParams('contact_posted');
    if (contact_posted !== undefined) {
        $('#product-section-9 .reviews').hide();
        $('#product-section-9 .write').show();
        document.querySelector("#product-section-9").scrollIntoView({ behavior: "instant" });

        if (!isMobile)
            $('.nav-menu').addClass('active');
    }

    let sync1 = $("#main-slider");
    let sync2 = $("#option-slider");
    let slidesPerPage = 5;
    let syncedSecondary = true;

    sync1.owlCarousel({
        items: 1,
        slideSpeed: 2000,
        nav: true,
        autoplay: false,
        dots: false,
        loop: true,
        margin: 10,
        responsiveRefreshRate: 200,
    }).on('changed.owl.carousel', syncPosition);

    sync2.on('initialized.owl.carousel', function () {
        sync2.find(".owl-item").eq(0).addClass("current");
    })
    .owlCarousel({
        items: slidesPerPage,
        nav: false,
        margin: 10,
        smartSpeed: 200,
        slideSpeed: 500,
        slideBy: slidesPerPage,
        responsiveRefreshRate: 100
    }).on('changed.owl.carousel', syncPosition2);

    function syncPosition(el) {
        //if you set loop to false, you have to restore this next line
        //var current = el.item.index;

        //if you disable loop you have to comment this block
        var count = el.item.count - 1;
        var current = Math.round(el.item.index - (el.item.count / 2) - .5);

        if (current < 0) {
            current = count;
        }
        if (current > count) {
            current = 0;
        }

        //end block

        sync2.find(".owl-item")
            .removeClass("current")
            .eq(current)
            .addClass("current");
        var onscreen = sync2.find('.owl-item.active').length - 1;
        var start = sync2.find('.owl-item.active').first().index();
        var end = sync2.find('.owl-item.active').last().index();

        if (current > end) {
            sync2.data('owl.carousel').to(current, 100, true);
        }
        if (current < start) {
            sync2.data('owl.carousel').to(current - onscreen, 100, true);
        }
    }

    function syncPosition2(el) {
        if (syncedSecondary) {
            var number = el.item.index;
            sync1.data('owl.carousel').to(number, 100, true);
        }
    }

    sync2.on("click", ".owl-item", function (e) {
        e.preventDefault();
        var number = $(this).index();
        sync1.data('owl.carousel').to(number, 300, true);
    });

});


$(window).on('resize', function(){
    if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        isMobile = true;
    }
    else {
        isMobile = false;
    }
    
    hSize = $(window).height();
    wSize = $(window).width();
});

$('#product-section-9 .btn-write-r').on('click', function() {
    $('#product-section-9 .reviews').hide();
    $('#product-section-9 .write').show();
});
$('#product-section-9 .btn-close').on('click', function() {
    $('#product-section-9 .reviews').show();
    $('#product-section-9 .write').hide();
});

$('#product-section-9 .stars .star.one').mouseover(function() {
    $('#product-section-9 .stars .star.one').addClass('active');
    $('#product-section-9 .stars .star.two').removeClass('active');
    $('#product-section-9 .stars .star.three').removeClass('active');
    $('#product-section-9 .stars .star.four').removeClass('active');
    $('#product-section-9 .stars .star.five').removeClass('active');
});
$('#product-section-9 .stars .star.two').mouseover(function() {
    $('#product-section-9 .stars .star.one').addClass('active');
    $('#product-section-9 .stars .star.two').addClass('active');
    $('#product-section-9 .stars .star.three').removeClass('active');
    $('#product-section-9 .stars .star.four').removeClass('active');
    $('#product-section-9 .stars .star.five').removeClass('active');
});
$('#product-section-9 .stars .star.three').mouseover(function() {
    $('#product-section-9 .stars .star.one').addClass('active');
    $('#product-section-9 .stars .star.two').addClass('active');
    $('#product-section-9 .stars .star.three').addClass('active');
    $('#product-section-9 .stars .star.four').removeClass('active');
    $('#product-section-9 .stars .star.five').removeClass('active');
});
$('#product-section-9 .stars .star.four').mouseover(function() {
    $('#product-section-9 .stars .star.one').addClass('active');
    $('#product-section-9 .stars .star.two').addClass('active');
    $('#product-section-9 .stars .star.three').addClass('active');
    $('#product-section-9 .stars .star.four').addClass('active');
    $('#product-section-9 .stars .star.five').removeClass('active');
});
$('#product-section-9 .stars .star.five').mouseover(function() {
    $('#product-section-9 .stars .star.one').addClass('active');
    $('#product-section-9 .stars .star.two').addClass('active');
    $('#product-section-9 .stars .star.three').addClass('active');
    $('#product-section-9 .stars .star.four').addClass('active');
    $('#product-section-9 .stars .star.five').addClass('active');
});
$('#product-section-9 .stars .star').mouseleave(function() {
    if (rating == 5) {
        $('#product-section-9 .stars .star.one').addClass('active');
        $('#product-section-9 .stars .star.two').addClass('active');
        $('#product-section-9 .stars .star.three').addClass('active');
        $('#product-section-9 .stars .star.four').addClass('active');
        $('#product-section-9 .stars .star.five').addClass('active');
    }
    else if (rating == 4) {
        $('#product-section-9 .stars .star.one').addClass('active');
        $('#product-section-9 .stars .star.two').addClass('active');
        $('#product-section-9 .stars .star.three').addClass('active');
        $('#product-section-9 .stars .star.four').addClass('active');
        $('#product-section-9 .stars .star.five').removeClass('active');
    }
    else if (rating == 3) {
        $('#product-section-9 .stars .star.one').addClass('active');
        $('#product-section-9 .stars .star.two').addClass('active');
        $('#product-section-9 .stars .star.three').addClass('active');
        $('#product-section-9 .stars .star.four').removeClass('active');
        $('#product-section-9 .stars .star.five').removeClass('active');
    }
    else if (rating == 2) {
        $('#product-section-9 .stars .star.one').addClass('active');
        $('#product-section-9 .stars .star.two').addClass('active');
        $('#product-section-9 .stars .star.three').removeClass('active');
        $('#product-section-9 .stars .star.four').removeClass('active');
        $('#product-section-9 .stars .star.five').removeClass('active');
    }
    else if (rating == 1) {
        $('#product-section-9 .stars .star.one').addClass('active');
        $('#product-section-9 .stars .star.two').removeClass('active');
        $('#product-section-9 .stars .star.three').removeClass('active');
        $('#product-section-9 .stars .star.four').removeClass('active');
        $('#product-section-9 .stars .star.five').removeClass('active');
    }
});
$('#product-section-9 .stars .star.one').on('click', function() {
    rating = 1;
    $('[name="contact[rate]"]').val(rating);
});
$('#product-section-9 .stars .star.two').on('click', function() {
    rating = 2;
    $('[name="contact[rate]"]').val(rating);
});
$('#product-section-9 .stars .star.three').on('click', function() {
    rating = 3;
    $('[name="contact[rate]"]').val(rating);
});
$('#product-section-9 .stars .star.four').on('click', function() {
    rating = 4;
    $('[name="contact[rate]"]').val(rating);
});
$('#product-section-9 .stars .star.five').on('click', function() {
    rating = 5;
    $('[name="contact[rate]"]').val(rating);
});